import { css, keyframes } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { CSSProperties } from "react";
import type { SkeletonProps } from ".";

const horizontalSkeletonKeyframes = (width: CSSProperties["width"]) => keyframes`
0% {
  background-position: -${width} 0;
}
100% {
  background-position: calc(${width} + 100%) 0;
}
`;

const diagonalSkeletonKeyframes = (width?: CSSProperties["width"]) => keyframes`
  0% {
      left: -(calc(${width}/2) + calc(${width} * 2));
    }
    100% {
      left: calc(3/2 * ${width});
    }
  `;

export const horizontalCSS = ({
  width,
  height,
  duration,
}: Pick<SkeletonProps<"div">, "width" | "height" | "duration">) =>
  css({
    width,
    height,
    backgroundColor: vars.semantic.color.surfaceSub,
    backgroundImage: `${`linear-gradient(90deg, ${vars.semantic.color.surfaceSub}, ${vars.semantic.color.surface}, ${vars.semantic.color.surfaceSub})`}`,
    backgroundRepeat: "no-repeat",

    animation: `${horizontalSkeletonKeyframes(width)} ${duration} ease-in-out infinite;`,
  });

export const diagonalCSS = ({
  width,
  height,
  duration,
}: Pick<SkeletonProps<"div">, "width" | "height" | "duration">) =>
  css({
    width,
    height,
    background: vars.semantic.color.surfaceSub,
    position: "relative",
    overflow: "hidden",

    "&:before": {
      content: '""',
      transform: "skewX(-45deg)",
      backgroundImage: `linear-gradient(90deg, ${vars.semantic.color.surfaceSub} 0px, ${vars.semantic.color.surface} calc(${width}/2), ${vars.semantic.color.surfaceSub} ${width})`,
      position: "absolute",
      backgroundRepeat: "repeat-x",
      left: `calc(((${width} / 2) + (${width} * 2)) * -1)`,
      width: `calc(${width} * 2)`,
      height: "100%",
      animation: `${diagonalSkeletonKeyframes(width)} ${duration} ease-in-out infinite`,
    },
  });
